// extracted by mini-css-extract-plugin
export var activityContainer = "_o3-0";
export var typingIndicatorContainer = "_o3-1";
export var typingIndicatorDot = "_o3-2";
export var wave = "_o3-3";